import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useAddEntityToSeason = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (entityId: string) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities`, {
        method: "POST",
        body: {
          status: "ACTIVE",
          entityId,
        },
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["seasonEntities", sport, organizationId, seasonId] });
    },
  });
};
